import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import { UserSuccessOutput } from './types';

export interface IEditUser {
  editUser: UserSuccessOutput;
}

export const EDIT_USER = gql`
  mutation editUser($input: EditUserInput!) {
    editUser(input: $input) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;

export const useEditUser = (
  options: MutationHookOptions<IEditUser, OperationVariables>,
) => {
  return useMutation<IEditUser, OperationVariables>(EDIT_USER, options);
};
